
export default {
  getRuleInfoData: '/v3/serveScore/new/starStandard',
  getRuleInfoDataV2: '/v3/serveScore/new/starStandardV2'
}
